import React from 'react';
import { View, Dimensions, Text, Image, ScrollView, ActivityIndicator, TouchableHighlight } from 'react-native';
import { CheckBox, Button } from 'react-native-elements';
import Lib from '../Lib';

const { IMG_DATA, USDT, TOKEN, TOKEN_NAME } = require('../Data');

class PanelAbout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: 'busy'
    };
  }

  async componentDidMount() {
    this.setState({ show: 'game' });
  }

  componentWillUnmount() {
  }

  render() {
    const msg = 'RTK Warriors are NFT collections that generate ' + TOKEN_NAME + ' (' + TOKEN + ') based on its power. RTK Warriors also return 100% minting cost when burned after 30 days.';
    const msg2 = 'Dragon Token is revenue stream token with rising price support. Current support price is ' + USDT + '.';
    return (
      <View style={{ paddingVertical: 10, paddingHorizontal: 20, backgroundColor: '#eee' }}>
        <TouchableHighlight onPress={() => Lib.openUrl('https://confluxscan.io/token/cfx:acdz1ag5zm8re9ur1jpzxrnc9ucvrx0c32zz20k6vd')}>
          <View>
            <Text style={{ textAlign: 'center' }}>RTK WARRIORS NFT</Text>
            <Text style={{ textAlign: 'center', fontSize: 10 }}>cfx:acdz1ag5zm8re9ur1jpzxrnc9ucvrx0c32zz20k6vd</Text>
          </View>
        </TouchableHighlight>
        <Text> </Text>
        <Text style={{ textAlign: 'center' }}>{msg.toUpperCase()}</Text>
        <Text> </Text>
      </View>
    );
  }

}

export default PanelAbout;
